import { useMemo } from 'react';
import { ICameraInfo } from '@thingsw/pitta-modules';
import { getAbleBatteryCloud } from '../utils/getAbleBatteryCloud';

const useAbleBatteryCloud = (camera?: ICameraInfo) => {
  const isAbleBatteryCloud = useMemo(() => {
    return getAbleBatteryCloud(camera);
  }, [camera]);

  return isAbleBatteryCloud;
};

export default useAbleBatteryCloud;
